




















import Vue from "vue";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { mdbContainer, mdbIcon } from "mdbvue";
import { MediaQuery as MQ } from "@/MediaQuery";
import { RouterIcons } from "@/router/RouterIcons";
import { RouterNames } from "@/router/RouterNames";
import { NavModule } from "@/store";

@Component({
  components: {
    mdbContainer,
    mdbIcon
  }
})
export default class BankSitemap extends Vue {
  navStore: NavModule = getModule(NavModule, this.$store);

  get cards(): any[] {
    const cards = [];
    cards.push({
      title: this.$tc("nav.bank.deposits"),
      icon: RouterIcons.BANK_DEPOSITS,
      route: RouterNames.BANK_DEPOSITS
    });
    if (this.navStore.allowBankTransfers) {
      cards.push({
        title: this.$tc("nav.bank.transfers"),
        icon: RouterIcons.BANK_TRANSFERS,
        route: RouterNames.BANK_TRANSFERS
      });
    }
    // { title: this.$tc('nav.shop.orders'), icon: 'gift', route: RouterNames.SHOP_ORDERS },
    cards.push({
      title: this.$tc("nav.bank.transactions"),
      icon: RouterIcons.BANK_TRANSACTIONS,
      route: RouterNames.BANK_TRANSACTIONS
    });
    cards.push({
      title: this.$tc("nav.account.paymentMethods"),
      icon: RouterIcons.ACCOUNT_PAYMENTMETHODS,
      route: RouterNames.ACCOUNT_PAYMENTMETHODS
    });
    cards.push({
      title: this.$tc("nav.bank.contributors"),
      icon: RouterIcons.ACCOUNT_CONTRIBUTORS,
      route: RouterNames.ACCOUNT_CONTRIBUTORS
    });
    // TODO: Leave in account or bank???
    // { title: this.$tc('nav.bank.contributors'), icon: 'group', route: RouterNames.ACCOUNT_CONTRIBUTORS } // TODO: Leave in account or bank???
    // { title: 'Alerts', icon: 'bell-o', route: RouterNames.HOME }, // TODO: Create route
    // { title: 'Refund & Donations', icon: 'heart', route: RouterNames.HOME } // TODO: Create route
    return cards;
  }

  // compute nested array of rows of cards
  get mqCards() {
    // determine number of cards per row based on media query (fine-mq)
    let cardsPerRow = 1;
    if (MQ.md) {
      cardsPerRow = 2;
    }
    if (MQ.lg) {
      cardsPerRow = 4;
    }
    // return cards into rows of x
    return this.cards.reduce((c, n, i) => {
      if (i % cardsPerRow === 0) c.push([]);
      c[c.length - 1].push(n);
      return c;
    }, []);
  }

  openRoute(routeName: string) {
    // console.log(`open route ${routeName}`)
    this.$router.push({ name: routeName });
  }
}
